import { venusShared } from '@solarApi';
import { users } from '@solarApiResources';

const formatUser = (user) => ({
  id: user.id, ...user.data,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchCurrentUser = async () => {
  const { data } = await venusShared.request({
    ...users.me,
  });

  return formatUser(data);
};
